module.exports = {
    region: 'id',
    registerUrl: 'https://top-trade.online', //注册地址
    title: '3T.online - Investasi Olahraga - Peluang Baru menghasilkan Uang', //标题
    description: '3T.online adalah platform investasi olahraga online terbesar di Asia, bereputasi, pendapatan stabil, sederhana dan mudah dimengerti. Pendaftaran gratis, platform stabil, keamanan tinggi, dipercaya dan dihargai oleh banyak pemain.', //描述
    tgUrl: '',
	googleId: '',
}